<template>
  <v-layout class="pt-4">
    <v-row>
      <v-col cols="12" md="7">
        <system-notifications></system-notifications>
      </v-col>
      <v-col cols="12" md="5">
        <unanswered-messages></unanswered-messages>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import {mapGetters} from 'vuex'
import SystemNotifications from './Widgets/SystemNotifications'
import UnansweredMessages from './Widgets/UnansweredMessages'

export default {
  components: {UnansweredMessages, SystemNotifications},
  name: 'AdminLayout',
  data() {
    return {}
  },
  computed: {
    ...mapGetters('auth', [
      'isAdmin'
    ])
  },
}
</script>